import { apiWrapper } from "@/services/api";

export const getDemandReservations = async (is_used) => {
  let response;
  try {
    response = await apiWrapper(
      "GET",
      `demand-reservations?is_used=${is_used}`
    );
    console.log("getDemandReservations response.data :>> ", response.data);
  } catch (err) {
    console.log('ERROR"" getDemandReservations():', err);
    throw err;
  }
  return response.data.reservations.reservations;
};
